import { useEffect, useRef } from "react";
import { useLoading } from "../../contexts/LoadingContext";

// When rendered as Suspense fallback, this component marks a loading task
// so our global overlay stays visible until the suspended content resolves.
const SuspenseCapture = () => {
  const { beginTask, endTask } = useLoading();
  const idRef = useRef(`suspense-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const id = idRef.current;
    beginTask(id);
    return () => endTask(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SuspenseCapture;
